import React, { useEffect, useState } from 'react';
import { ChevronRight } from 'lucide-react';
import { useNavigation } from '../../context/NavigationContext';
import { Screen } from '../../types';
import { MOCK_PRODUCTS } from '../../context/AppContext';
const BANNERS = [{
  id: 1,
  title: 'Summer Sale',
  subtitle: 'Up to 50% Off on Top Electronics',
  cta: 'Shop Now',
  bg: 'bg-gradient-to-br from-primary-700 via-primary to-primary-400',
  productIds: ['p1', 'p3'],
  screen: Screen.FLASH_DEALS,
  accent: 'bg-accent'
}, {
  id: 2,
  title: 'Tech Week',
  subtitle: 'Latest Gadgets & Accessories',
  cta: 'Explore',
  bg: 'bg-gradient-to-br from-secondary via-primary-800 to-primary-700',
  productIds: ['p6', 'p16'],
  screen: Screen.PRODUCT_LIST,
  params: {
    categoryId: 'c1',
    categoryName: 'Electronics'
  },
  accent: 'bg-primary-300'
}, {
  id: 3,
  title: 'Flash Deals',
  subtitle: "Ends in 24 Hours — Don't Miss Out!",
  cta: 'Grab Deals',
  bg: 'bg-gradient-to-br from-accent-600 via-accent to-accent-400',
  productIds: ['p2', 'p14'],
  screen: Screen.FLASH_DEALS,
  accent: 'bg-white'
}, {
  id: 4,
  title: 'Style Edit',
  subtitle: 'Trending Fashion & Accessories',
  cta: 'Shop Fashion',
  bg: 'bg-gradient-to-br from-primary-800 via-primary-600 to-primary-400',
  productIds: ['p4', 'p10'],
  screen: Screen.PRODUCT_LIST,
  params: {
    categoryId: 'c2',
    categoryName: 'Fashion'
  },
  accent: 'bg-accent-400'
}];
export function BannerCarousel() {
  const [current, setCurrent] = useState(0);
  const {
    navigate
  } = useNavigation();
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent(prev => (prev + 1) % BANNERS.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);
  const getProduct = (id: string) => MOCK_PRODUCTS.find(p => p.id === id);
  return <div className="relative w-full h-44 rounded-2xl overflow-hidden shadow-md" data-id="element-72">
      <div className="flex transition-transform duration-500 ease-out h-full" style={{
      transform: `translateX(-${current * 100}%)`
    }} data-id="element-73">
        {BANNERS.map(banner => {
        const products = banner.productIds.map(getProduct).filter(Boolean);
        return <div key={banner.id} onClick={() => navigate(banner.screen, (banner as any).params)} className={`w-full h-full shrink-0 ${banner.bg} flex items-center relative cursor-pointer overflow-hidden`} data-id="element-74">
              {/* Decorative circles */}
              <div className="absolute -top-8 -right-8 w-32 h-32 rounded-full bg-white/5" data-id="element-75" />
              <div className="absolute -bottom-6 -left-6 w-24 h-24 rounded-full bg-white/5" data-id="element-76" />
              <div className="absolute top-4 right-20 w-8 h-8 rounded-full bg-white/10" data-id="element-77" />

              {/* Text Content */}
              <div className="flex-1 pl-5 pr-2 py-4 z-10 flex flex-col justify-center" data-id="element-78">
                <span className={`text-[10px] font-bold uppercase tracking-wider ${banner.id === 3 ? 'text-white/80' : 'text-white/70'} mb-1`} data-id="element-79">
                  Limited Offer
                </span>
                <h2 className="text-xl font-bold text-white leading-tight mb-1" data-id="element-80">
                  {banner.title}
                </h2>
                <p className="text-xs text-white/80 leading-snug mb-3 max-w-[160px]" data-id="element-81">
                  {banner.subtitle}
                </p>
                <div className="flex items-center gap-1.5 bg-white/20 backdrop-blur-sm w-fit px-3 py-1.5 rounded-full" data-id="element-82">
                  <span className="text-xs font-bold text-white" data-id="element-83">
                    {banner.cta}
                  </span>
                  <ChevronRight className="w-3.5 h-3.5 text-white" data-id="element-84" />
                </div>
              </div>

              {/* Product Images */}
              <div className="relative w-[140px] h-full flex items-center justify-center shrink-0 mr-3" data-id="element-85">
                {products[0] && <div className="absolute z-20 w-28 h-28 rounded-2xl overflow-hidden shadow-xl border-2 border-white/20 bg-white -rotate-3 translate-y-1" data-id="element-86">
                    <img src={products[0]!.image} alt={products[0]!.name} className="w-full h-full object-cover" data-id="element-87" />
                    {products[0]!.discount && <div className="absolute bottom-1.5 left-1.5 bg-error text-white text-[9px] font-bold px-1.5 py-0.5 rounded-md shadow" data-id="element-88">
                        -{products[0]!.discount}%
                      </div>}
                  </div>}
                {products[1] && <div className="absolute z-10 w-20 h-20 rounded-xl overflow-hidden shadow-lg border-2 border-white/15 bg-white translate-x-6 -translate-y-6 rotate-6 opacity-80" data-id="element-89">
                    <img src={products[1]!.image} alt={products[1]!.name} className="w-full h-full object-cover" data-id="element-90" />
                  </div>}
              </div>
            </div>;
      })}
      </div>

      {/* Dot Indicators */}
      <div className="absolute bottom-3 left-0 right-0 flex justify-center gap-1.5" data-id="element-91">
        {BANNERS.map((_, idx) => <button key={idx} onClick={e => {
        e.stopPropagation();
        setCurrent(idx);
      }} className={`h-1.5 rounded-full transition-all duration-300 ${current === idx ? 'w-5 bg-white' : 'w-1.5 bg-white/40'}`} data-id="element-92" />)}
      </div>
    </div>;
}